import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function MicrosoftComplete() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const ticket = new URLSearchParams(window.location.hash.slice(1)).get("ticket");
    if (!ticket) {
      navigate("/login?sso_error=1", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/microsoft/exchange", { ticket });
        setToken(data.access_token);
        const me = await api.get("/auth/me");
        setUser(me.data);
        const next = sessionStorage.getItem("radar_login_next") || "/";
        sessionStorage.removeItem("radar_login_next");
        navigate(next, { replace: true });
      } catch {
        navigate("/login?sso_error=1", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex h-screen items-center justify-center gap-3 text-slate-400" data-testid="ms-complete">
      <Loader2 className="h-5 w-5 animate-spin" /> Connexion en cours…
    </div>
  );
}
